<template>
  <v-container class="page-earlypay2">
    <div class="bg"></div>
    <DateSlider
      showFormat="M월 DD일 (ddd)"
      class="width-100"
      :date="date"
      :max="today"
      @update:date="$router.replace({ query: { date: $event } })"
      @onClickDate="
        $router.push({
          path: '/earlypay/statistics/month',
          query: { date },
        })
      "
    />
    <DataFetch :date="date">
      <template slot-scope="{ data, isLoading }">
        <div v-if="!isLoading && data">
          <CommonSection>
            <template v-slot:content>
              <DailyTotal :data="data" />
            </template>
          </CommonSection>

          <Payment :data="data.paymentsDetail" />
        </div>
      </template>
    </DataFetch>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

const today = moment().format('YYYY-MM-DD')

/**
 * 정산 페이지는 미래 날짜 조회 불가하므로
 * 쿼리스트링으로 받은 date 날짜 검사
 */
function queryNavigationGuard(to, from, next) {
  const date = to.query.date
  if (!date) {
    // 쿼리에 날짜가 없으면 route객체에 오늘 날짜 정보만 넣어서 보내줌
    to.query.date = today
    return next()
  } else if (isNaN(Date.parse(date)) || moment(date).isAfter(today)) {
    // 날짜 형식이 아니거나 오늘 이후인 경우 오늘 날짜 페이지로 이동
    return next({ path: `${to.path}?date=${today}` })
  }

  next()
}

export default {
  components: {
    DateSlider: () => import('@/components/earlypay/template/DateSlider.vue'),
    DataFetch: () => import('@/components/earlypay/DataFetch.vue'),
    CommonSection: () => import('@/components/earlypay/template/CommonSection.vue'),
    DailyTotal: () => import('@/components/earlypay/template/DailyTotal.vue'),
    Payment: () => import('@/components/earlypay/template/EarlypayPayment.vue'),
  },
  data() {
    return {
      date: this.$route.query.date,
      today,
      offer: null,
    }
  },
  beforeRouteEnter: queryNavigationGuard,
  beforeRouteUpdate: queryNavigationGuard,
  computed: {
    ...mapState('contract', {
      contractCurrent: 'current',
    }),
  },
  watch: {
    contractCurrent: {
      deep: true,
      immediate: true,
      async handler(v) {
        if (!v) {
          return
        }
        // 선정산이 꺼져있으면 강제로 메인으로 이동시킨다
        if (v.isEarlyPaymentEnabled === false) {
          await this.$router.replace('/')
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.page-earlypay2 {
  :deep .section-container section {
    background-color: white;

    .layout {
      margin-bottom: 10px;
      font-weight: bold;
    }

    .layout.subtitle {
      font-size: 13px;
    }

    .layout.subtitle::before {
      content: '└';
    }

    p:last-child {
      margin-top: 10px;
      margin-bottom: 0;
      font-size: 12px;
      text-align: center;
    }

    img.icon {
      width: 17px;
      margin-right: 5px;
    }
  }

  @media screen and (max-width: 319px) {
    padding: 12px 0;
  }
}
</style>
